<div [formGroup]="form">
  <div class="form-control-container mb-2">
    <label class="form-label" for="meditionNumber">{{ 'Inventory::Entity.LidarInventoryDataEntry.MeditionNumberToUnprocess' | abpLocalization }} <span class="form-label-required">*</span></label>
    <zn-single-select id="meditionNumber" [optionsLoader]="meditionNumbers" formControlName="meditionNumber" [localizationResource]="localizationResource" />
  </div>
  <div class="form-control-container">
    <label class="form-label" for="standNumbers">{{ 'Inventory::Entity.LidarInventoryDataEntry.Stands' | abpLocalization }} <span class="form-label-required">*</span></label>
    <zn-multi-select id="standNumbers" [options]="standOptions()" [deferSelection]="false" formControlName="standNumbers" [localizationResource]="localizationResource" />
  </div>
</div>
